export default "__VITE_ASSET__CAK8LAax__"